// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2OMIU","notes":"Notes_notes__37UJo","note":"Notes_note__2n6vm","markdown":"Notes_markdown__37lIa"};